import Loadable, { NullLoader } from '@comeon/loadable';
import { PromotionCarouselFallback, RecommendedBetsCarouselFallback } from './sportsbook-async-fallbacks';
import { RecommendedBetDto } from './api/sbapi/sbapi-api-model';
import { OddsFormat } from './sportsbook-types';

const ExplorePageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-lobby" */
			'./features/explore-page/sportsbook-explore-page-container'
		),
	loading: NullLoader
});

const BetslipContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-lobby-betslip-container" */
			'./features/betslip/sportsbook-betslip-container'
		),
	loading: NullLoader
});

const PoolXContainer = Loadable<{ className?: string }>({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-poolx" */
			'./features/poolx/sportsbook-poolx-container'
		),
	loading: NullLoader
});

const PromotionCarouselContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-lobby" */
			'./features/promotion-carousel/sportsbook-promotion-carousel-container'
		),
	loading: () => <PromotionCarouselFallback />
});
const BetRecommendationsCarousel = Loadable<{
	carouselName: string;
	recommendedBets: RecommendedBetDto[];
	isLoading: boolean;
	oddsFormat: OddsFormat;
	onBetClick: (recommendedBet: RecommendedBetDto) => void;
	activeSelectionIds?: string[];
	successSelectionIds?: string[];
	shouldDeepLink?: boolean;
	showArrows?: boolean;
	paddingX?: number;
}>({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-lobby" */
			'./components/bet-recommendations/sportsbook-bet-recommendations-carousel'
		),
	loading: () => <RecommendedBetsCarouselFallback />
});

const PreCannedRecommendationsCarousel = Loadable<{
	recommendedBets: RecommendedBetDto[];
	isLoading: boolean;
	oddsFormat: OddsFormat;
	onBetClick: (recommendedBet: RecommendedBetDto) => void;
	activeSelectionIds?: string[];
	showArrows?: boolean;
	paddingX?: number;
}>({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-lobby" */
			'./components/bet-recommendations/sportsbook-pre-canned-recommendations-carousel'
		),
	loading: () => <RecommendedBetsCarouselFallback />
});

export {
	ExplorePageContainer,
	BetslipContainer,
	PromotionCarouselContainer,
	BetRecommendationsCarousel,
	PreCannedRecommendationsCarousel,
	PoolXContainer
};
